import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  OnDestroy, Input, ChangeDetectorRef
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { JanusService, StateService } from '@shared/services';
import { MultiMedia, UserMedia, VoiceState } from '@models';
import { VideoType } from '@enums';
import { RealtimeDatabaseSubscriptionsService } from '../../services/rtdb-subscriptions.service';
import { untilDestroyed } from '@ngneat/until-destroy';
import { AppService } from '@shared/services/app.service';

@Component({
  selector: 'thevatra-participant',
  templateUrl: './participant.component.html',
  styleUrls: ['./participant.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParticipantComponent implements OnInit, OnDestroy {
  destroyed$ = new Subject<boolean>();

  public video: MultiMedia;
  public userMedia = new UserMedia();
  private media$$: Subscription;

  @Input() set source(video: MultiMedia) {
    const isChanged = !this.video || this.video.video.id !== video.video.id;
    this.video = video;

    if (isChanged) {
      if (this.media$$) {
        this.media$$.unsubscribe();
      }
      this.media$$ = this.rtdbSubscriptionService
        .getUserInfo(this.video.video.id, !this.video.video.remote).media$
        .pipe(untilDestroyed(this))
        .subscribe((m) => {
          this.userMedia = m;
          this.cdr.detectChanges();
        });
    }

    this.cdr.detectChanges();
  }
  get source(): MultiMedia {
    return this.video;
  }

  constructor(public stateService: StateService,
              public janusService: JanusService,
              private readonly rtdbSubscriptionService: RealtimeDatabaseSubscriptionsService,
              private readonly cdr: ChangeDetectorRef,
              private appService: AppService,
  ) {}

  ngOnInit() {
  }

  isScreen(media: MultiMedia): boolean {
    return media.video.type === VideoType.screen
      || this.appService.isScreen(media.video.name) || false; // dirty hack
  }

  talking$(id: number) {
    return this.janusService.voiceState$.pipe(
      takeUntil(this.destroyed$),
      map((voiceState: VoiceState) => voiceState.userId === id && voiceState.talking)
    );
  }

  raiseVideoToTop(id: number) {
    this.stateService.raisedToTopVideoId = id;
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
